import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { ListItemIcon, Menu } from '@mui/material';
import { Avatar, Box, Divider, IconButton, MenuItem, Typography } from '@weave-mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../auth/AuthProvider';
import RoleIndicator from './RoleIndicator';
/**
 * User avatar in the AppBar — profile dropdown with sign-out (pim-db-migration-admin pattern).
 */
export default function UserMenu() {
    const { user, logout } = useAuth();
    const [anchorEl, setAnchorEl] = useState(null);
    if (!user)
        return null;
    const open = Boolean(anchorEl);
    const displayName = user.name || user.email;
    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleLogout = () => {
        handleClose();
        logout();
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { onClick: handleOpen, sx: { p: 0.5 }, "aria-label": "user menu", children: _jsx(Avatar, { name: displayName, sx: {
                        width: 32,
                        height: 32,
                        fontSize: '0.8rem',
                        fontWeight: 700,
                    } }) }), _jsxs(Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, slotProps: { paper: { sx: { minWidth: 220, mt: 0.5 } } }, children: [_jsxs(Box, { sx: { px: 2, py: 1.5, userSelect: 'none', pointerEvents: 'none' }, children: [_jsx(Typography, { variant: "subtitle2", fontWeight: "bold", noWrap: true, children: displayName }), _jsx(Typography, { variant: "caption", color: "text.secondary", display: "block", noWrap: true, sx: { mt: 0.25 }, children: user.email }), _jsx(Box, { sx: { mt: 0.75 }, children: _jsx(RoleIndicator, {}) })] }), _jsx(Divider, {}), _jsxs(MenuItem, { onClick: handleLogout, sx: { py: 1.25 }, children: [_jsx(ListItemIcon, { children: _jsx(LogoutIcon, { fontSize: "small" }) }), _jsx(Typography, { variant: "body2", children: "Sign out" })] })] })] }));
}
